(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class MobileMenu {
    constructor() {
      this.menu = document.querySelector('[data-mobile-menu]');
      this.toggleButton = document.querySelector('[data-mobile-menu-toggle]');
      this.closeButtons = document.querySelectorAll('[data-mobile-menu-close]');
      this.desktopBreakpoint = 1024; // lg breakpoint

      this.init();
    }

    init() {
      if (!this.menu || !this.toggleButton) return;

      this.toggleButton.addEventListener('click', () => this.open());

      this.closeButtons.forEach(button => {
        button.addEventListener('click', () => this.close());
      });

      // Close on escape key
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.menu.classList.contains('is-open')) {
          this.close();
        }
      });

      // Close when clicking a link
      this.menu.querySelectorAll('.mobile-menu__link').forEach(link => {
        link.addEventListener('click', () => this.close());
      });

      // Close menu when resizing to desktop
      window.addEventListener('resize', () => {
        if (window.innerWidth >= this.desktopBreakpoint && this.menu.classList.contains('is-open')) {
          this.close();
        }
      });
    }

    open() {
      this.menu.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }

    close() {
      this.menu.classList.remove('is-open');
      document.body.style.overflow = '';
    }
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => new MobileMenu());
  } else {
    new MobileMenu();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["password-gate"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const STORAGE_KEY = 'wholesale_access';
    const PASSWORD = 'uniquebatik';

    const overlay = document.querySelector('[data-password-gate]');
    const form = document.querySelector('[data-password-form]');
    const input = document.querySelector('[data-password-input]');
    const error = document.querySelector('[data-password-error]');

    if (!overlay || !form) return;

    // Check if already authenticated
    if (sessionStorage.getItem(STORAGE_KEY) === 'true') {
      overlay.classList.add('is-unlocked');
    }

    // Handle form submission
    form.addEventListener('submit', function(e) {
      e.preventDefault();

      const enteredPassword = input.value.trim();

      if (enteredPassword === PASSWORD) {
        sessionStorage.setItem(STORAGE_KEY, 'true');
        overlay.classList.add('is-unlocked');
        error.classList.add('hidden');
      } else {
        error.classList.remove('hidden');
        input.value = '';
        input.focus();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-main"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const variantDataEl = document.getElementById('product-variants-data');
    const productData   = variantDataEl ? JSON.parse(variantDataEl.textContent) : null;

    // ── Quantity ─────────────────────────────────────────────────
    window.updateQuantity = function(change) {
      var input    = document.getElementById('quantity-input');
      var newValue = parseInt(input.value) + change;
      if (newValue >= 1) input.value = newValue;
    };

    // ── Gallery ──────────────────────────────────────────────────
    var gallery = document.querySelector('[data-gallery]');
    if (gallery) {
      var allSlides = Array.from(gallery.querySelectorAll('[data-slide]'));
      var allThumbs = Array.from(gallery.querySelectorAll('[data-thumb]'));
      var prevBtn   = gallery.querySelector('[data-gallery-prev]');
      var nextBtn   = gallery.querySelector('[data-gallery-next]');
      var visible   = allSlides.slice(); // currently visible slides
      var current   = 0;

      function updateThumbActive() {
        allThumbs.forEach(function(t) { t.classList.remove('is-active'); });
        if (!visible[current]) return;
        var globalIdx = allSlides.indexOf(visible[current]);
        if (allThumbs[globalIdx]) {
          allThumbs[globalIdx].classList.add('is-active');
          allThumbs[globalIdx].scrollIntoView({ block: 'nearest', inline: 'nearest' });
        }
      }

      function goTo(index) {
        if (!visible.length) return;
        if (visible[current]) visible[current].classList.remove('is-active');
        current = ((index % visible.length) + visible.length) % visible.length;
        if (visible[current]) visible[current].classList.add('is-active');
        updateThumbActive();
      }

      // Filter gallery slides by colour name (matched against image alt text)
      function filterByColor(colorValue) {
        var query   = colorValue ? colorValue.toLowerCase().trim() : '';
        var matched = query
          ? allSlides.filter(function(s) {
              return (s.dataset.alt || '').toLowerCase().indexOf(query) !== -1;
            })
          : allSlides.slice();

        // Fall back to all slides if alt text hasn't been set yet
        visible = matched.length ? matched : allSlides.slice();

        // Show / hide slides and thumbs
        allSlides.forEach(function(s) { s.classList.remove('is-active'); });
        allSlides.forEach(function(s, i) {
          if (allThumbs[i]) {
            allThumbs[i].style.display = visible.indexOf(s) !== -1 ? '' : 'none';
          }
        });

        // Activate first visible slide
        current = 0;
        if (visible[0]) visible[0].classList.add('is-active');
        updateThumbActive();

        // Show / hide arrows
        var multiSlide = visible.length > 1;
        if (prevBtn) prevBtn.style.display = multiSlide ? '' : 'none';
        if (nextBtn) nextBtn.style.display = multiSlide ? '' : 'none';
      }

      // Thumb clicks navigate within visible set
      allThumbs.forEach(function(thumb, globalIdx) {
        thumb.addEventListener('click', function() {
          var vIdx = visible.indexOf(allSlides[globalIdx]);
          if (vIdx !== -1) goTo(vIdx);
        });
      });

      if (prevBtn) prevBtn.addEventListener('click', function() { goTo(current - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function() { goTo(current + 1); });

      // Swipe support
      var touchStartX = 0;
      gallery.addEventListener('touchstart', function(e) {
        touchStartX = e.changedTouches[0].screenX;
      }, { passive: true });
      gallery.addEventListener('touchend', function(e) {
        var diff = touchStartX - e.changedTouches[0].screenX;
        if (Math.abs(diff) > 40) goTo(diff > 0 ? current + 1 : current - 1);
      });

      // Expose filter for variant switcher
      window.galleryFilterByColor = filterByColor;

      // Apply filter on page load using the default selected colour
      var defaultSwatch = document.querySelector('.product-option__swatches .variant-option:checked');
      if (defaultSwatch) filterByColor(defaultSwatch.value);
    }

    // ── Variant selection ────────────────────────────────────────
    if (productData && productData.variants) {
      var variantInputs   = document.querySelectorAll('.variant-option');
      var variantIdInput  = document.getElementById('product-variant-id');
      var addToCartButton = document.querySelector('.product-main__add-to-cart');
      var priceElement    = document.getElementById('product-price');

      function getSelectedOptions() {
        var opts = [];
        variantInputs.forEach(function(input) {
          if ((input.type === 'radio' && input.checked) || input.tagName === 'SELECT') {
            opts[parseInt(input.dataset.optionPosition) - 1] = input.value;
            var container = input.closest('[data-option-index]');
            if (container) {
              var label = container.querySelector('[data-option-label]');
              if (label) label.textContent = input.value;
            }
          }
        });
        return opts;
      }

      function findMatchingVariant(opts) {
        return productData.variants.find(function(v) {
          return v.options.every(function(o, i) { return o === opts[i]; });
        });
      }

      function updateProduct() {
        var opts    = getSelectedOptions();
        var variant = findMatchingVariant(opts);
        if (!variant) return;

        if (variantIdInput) variantIdInput.value = variant.id;

        if (priceElement && variant.price) {
          priceElement.textContent = new Intl.NumberFormat('en-US', {
            style: 'currency', currency: 'USD'
          }).format(variant.price / 100);
        }

        if (addToCartButton) {
          addToCartButton.disabled    = !variant.available;
          addToCartButton.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
        }

        // Show/hide notify form
        var notifyWrap = document.getElementById('notify-me-wrap');
        var notifyInfo = document.getElementById('notify-product-info');
        if (notifyWrap) {
          notifyWrap.style.display = variant.available ? 'none' : 'block';
        }
        if (notifyInfo) {
          notifyInfo.value = (productData.product_title || '') + ' \u2014 ' + variant.title;
        }

        // Filter gallery by selected colour
        var swatch = document.querySelector('.product-option__swatches .variant-option:checked');
        if (swatch && window.galleryFilterByColor) window.galleryFilterByColor(swatch.value);
      }

      variantInputs.forEach(function(input) {
        input.addEventListener('change', updateProduct);
      });
    }

    // ── Accordions ───────────────────────────────────────────────
    document.querySelectorAll('[data-accordion-trigger]').forEach(function(trigger) {
      trigger.addEventListener('click', function() {
        var content  = this.nextElementSibling;
        var icon     = this.querySelector('.accordion-icon');
        var isHidden = content.classList.contains('hidden');
        content.classList.toggle('hidden', !isHidden);
        icon.textContent = isHidden ? '−' : '+';
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["protected-content"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const STORAGE_KEY = 'wholesale_access';
    const PASSWORD = 'uniquebatik';

    const gate = document.querySelector('[data-password-gate]');
    const content = document.querySelector('[data-password-content]');
    const form = document.querySelector('[data-password-form]');
    const input = document.querySelector('[data-password-input]');
    const error = document.querySelector('[data-password-error]');

    if (!gate || !content || !form) return;

    // Check if already authenticated
    if (sessionStorage.getItem(STORAGE_KEY) === 'true') {
      gate.classList.add('hidden');
      content.classList.remove('hidden');
    }

    // Handle form submission
    form.addEventListener('submit', function(e) {
      e.preventDefault();

      const enteredPassword = input.value.trim();

      if (enteredPassword === PASSWORD) {
        sessionStorage.setItem(STORAGE_KEY, 'true');
        gate.classList.add('hidden');
        content.classList.remove('hidden');
        error.classList.add('hidden');
      } else {
        error.classList.remove('hidden');
        input.value = '';
        input.focus();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
